<template>
  <header >
       <div v-if="!loggedIn">
         <img alt="" :src="LogoPath"  class="loginlogo" >
       </div>
       
        
       
       <div v-if="loggedIn" class=""> 
         <!-- horizFlexStretch -->
          <div class="">
            <!-- vertFlexTop leftjustified -->
            <img alt="school logo" :src="LogoPath"  class="logo" v-if="LogoPath!=''">
         </div>
         <div class="" v-if="requireLogin">
            <!-- vertFlexTop rightjustified -->
         <!--   <label class="headertextbold">{{loggedInUser.name}}</label>
           <label class="headertext">{{loggedInUser.email}}</label>
           <label class="headertext">ID#: {{loggedInUser.code}}</label> -->
           <linkbutton class="logoutButton" toplabel="Logout" @click="logout()" />
         </div>
       </div>
        
    </header>
</template>

<script>
 import {mapFields} from 'vuex-map-fields'
 import linkbutton from './controls/linkbutton.vue'
export default {
    name:'svheader',
    components:{
        linkbutton
    },
    computed:{
        ...mapFields([
            'loggedInUser',
            'loggedIn',
            'logoImageBasePath',
            'logoOverride',
            'requireLogin',
            'wasUpdated'
        ]),
        LogoPath(){
            if(this.logoOverride!=''){
                return this.logoImageBasePath + this.logoOverride
            }else{
                return './../' + this.logofile
            }
            
        },
        logofile(){
  
            return window.SCHOOL_LOGO
        }
    },
    methods:{
        logout(){
            this.$emit('logout')
        },
        
    }
}
</script>

<style>

.vertFlexTop{
  display:flex;
  flex-direction: column;
  margin:5px;
  align-items: top;
}
.logo{
      height:70px;
  }
  .loginlogo{
      height:80px;
      margin-right:0px;
      margin-top:10px;
    }
</style>